/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getRecommendedDidCredentials.defs.js'
export { main as default } from './getRecommendedDidCredentials.defs.js'
